module.exports = __webpack_public_path__ + "img/math-dash.cb63d7de.svg";